import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜主题索引
          </h2>
          <p className="text-sm text-foreground-500">按主题分类浏览 · 快速找到你想吃的瓜</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleScroll('#cards')}
              className="group flex flex-col items-center text-center p-6 rounded-2xl bg-background-100 hover:bg-primary-50/50 border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-700`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-800 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}